import { Link } from 'react-router-dom';
import { vinegar } from '@/mocks/products';

const VinegarSection = () => {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden" style={{ fontFamily: "'Sora', sans-serif" }}>
      {/* Background — balcão de cozinha (mesmo fundo do painel) */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_463fb4216b246ddf205753260ee1bc2a_bb3ba0d4.jpg"
          alt="Balcão de cozinha rústico vinagre"
          className="w-full h-full object-cover object-center"
          style={{ filter: 'blur(2px) brightness(0.55)', transform: 'scale(1.05)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1E230F]/90 via-[#1E230F]/65 to-[#1E230F]/20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#1E230F]/25 to-[#1E230F]/55"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left - Content */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-[#878450]/60"></div>
              <span className="text-[#878450] text-xs font-semibold tracking-widest uppercase">Artesanal Colonial</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#FCF1D7] mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Vinagre Tinto<br />
              <span className="text-[#878450] italic font-light">Colonial</span>
            </h2>
            <p className="text-[#FCF1D7]/75 text-sm md:text-base leading-relaxed mb-8 max-w-md">
              {vinegar.description}
            </p>

            {/* Options */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              {vinegar.options.map((opt) => (
                <div
                  key={opt.volume}
                  className="flex-1 rounded-xl border border-[#878450]/30 bg-[#FCF1D7]/10 backdrop-blur-sm p-5 hover:border-[#878450]/60 transition-all cursor-default"
                >
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-[#FCF1D7] font-bold text-2xl" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {opt.volume}
                    </span>
                    <span className="bg-[#710005]/80 text-[#FCF1D7] text-xs px-2.5 py-1 rounded-full">
                      {opt.tag}
                    </span>
                  </div>
                  <p className="text-[#FCF1D7]/60 text-xs leading-relaxed">{opt.description}</p>
                </div>
              ))}
            </div>

            {/* Features */}
            <div className="grid grid-cols-2 gap-3 mb-8">
              {[
                { icon: 'ri-leaf-line', text: '' },
                { icon: 'ri-drop-line', text: 'Acidez equilibrada' },
                { icon: 'ri-heart-line', text: 'Acidez natural pura' },
                { icon: 'ri-award-line', text: 'Método tradicional' },
              ].map((feat) => (
                <div key={feat.text} className="flex items-center gap-2 text-[#FCF1D7]/70">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${feat.icon} text-[#878450] text-sm`}></i>
                  </div>
                  <span className="text-xs">{feat.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mb-8">
              <a
                href="https://wa.me/5500000000000"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-[#710005] text-[#FCF1D7] rounded-full text-sm font-semibold hover:bg-[#2C0000] transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                Pedir pelo WhatsApp
              </a>
              <Link
                to="/vinagre"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-[#878450]/40 text-[#FCF1D7] rounded-full text-sm font-medium hover:bg-[#FCF1D7]/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Saiba Mais <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            {/* Vasilha de salada — abaixo dos botões */}
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-3 sm:gap-4">
              <img
                src="https://public.readdy.ai/ai/img_res/ba15413f-ed18-45db-b09e-8dc9ab14904a.png"
                alt="Vasilha de salada com alface, rúcula, cebola e tomate"
                className="flex-shrink-0"
                style={{ height: '160px', width: 'auto', objectFit: 'contain', filter: 'drop-shadow(0 8px 20px rgba(0,0,0,0.45))' }}
              />
              <div className="text-center sm:text-left">
                <p className="text-xs font-semibold tracking-wide uppercase mb-1" style={{ color: '#878450' }}>Sugestão de uso</p>
                <p className="text-[#FCF1D7]/65 text-xs leading-relaxed">Alface · Rúcula · Cebola picadinha · Tomate em rodela</p>
                <p className="text-[#FCF1D7]/50 text-xs mt-1 leading-relaxed italic">Regue com nosso vinagre colonial e transforme qualquer salada.</p>
              </div>
            </div>
          </div>

          {/* Right - garrafas responsivas, sempre visíveis */}
          <div className="flex items-end justify-center gap-4 md:gap-8 pt-8 pb-0">

            {/* Garrafa grande 2L */}
            <div className="relative flex flex-col items-center">
              <img
                src="https://public.readdy.ai/ai/img_res/5ae3b03c-a4c1-4c80-bb1a-31c85e416ddf.png"
                alt="Vinagre Colonial 2L"
                className="w-auto"
                style={{
                  height: 'clamp(280px, 45vw, 600px)',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 20px 36px rgba(0,0,0,0.65))',
                }}
              />
              <span className="mt-3 bg-[#710005]/95 text-[#FCF1D7] text-sm font-bold px-4 py-1.5 rounded-full shadow-lg">2L</span>
            </div>

            {/* Garrafa pequena 750ml */}
            <div className="relative flex flex-col items-center">
              <img
                src="https://public.readdy.ai/ai/img_res/1f454eff-b149-4b37-b2a3-2bc41aef30e9.png"
                alt="Vinagre Colonial 750ml"
                className="w-auto"
                style={{
                  height: 'clamp(200px, 32vw, 430px)',
                  objectFit: 'contain',
                  filter: 'drop-shadow(0 16px 28px rgba(0,0,0,0.60))',
                }}
              />
              <span className="mt-3 bg-[#2C0000]/95 text-[#FCF1D7] text-xs font-bold px-3 py-1 rounded-full shadow">750ml</span>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default VinegarSection;
